export default function pluralizeElements(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return "елемент";
  } else if (
    mod10 >= 2 &&
    mod10 <= 4 &&
    !(mod100 >= 12 && mod100 <= 14)
  ) {
    return "елементи";
  } else {
    return "елементів";
  }
}


export const getItemsCountTable = (arr: any[]) => (arr.length > 5 ? 5 : arr.length);